// Each circle's colour: the ring around your picture while you're in it, so you can tell at a glance where you are,
// and its dot in the list of your circles. A small set to pick from in Circle settings, kept clear of the colours that
// already mean something (the logo's coral and violet are Everyone, pine teal is what's selected, terracotta is birthdays and
// what's coming up). The colours themselves are theme roles (--circle-<name> in styles/theme.css).
export const CIRCLE_COLORS = ['sage', 'olive', 'ochre', 'clay', 'rose', 'plum', 'iris', 'harbor'] as const
export type CircleColor = (typeof CIRCLE_COLORS)[number]

export const CIRCLE_COLOR_LABELS: Record<CircleColor, string> = {
  sage: 'Sage',
  olive: 'Olive',
  ochre: 'Ochre',
  clay: 'Clay',
  rose: 'Rose',
  plum: 'Plum',
  iris: 'Iris',
  harbor: 'Harbor',
}

const isColor = (x: unknown): x is CircleColor => CIRCLE_COLORS.includes(x as CircleColor)

// What a circle shows: its own colour, or the first one for a circle that has none (an older server).
export const colorOf = (color: string | null | undefined): CircleColor => (isColor(color) ? color : CIRCLE_COLORS[0])

// A new circle's colour: the first one you aren't already using in another circle, so yours start out different;
// once you've used them all, they go round again.
export function nextColor(taken: (string | null)[]): CircleColor {
  const free = CIRCLE_COLORS.find((x) => !taken.includes(x))
  return free ?? CIRCLE_COLORS[taken.length % CIRCLE_COLORS.length]!
}
